import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederBarnestipendDto from '../Models/VeilederBarnestipendDto';
import { connect } from 'react-redux';
import { VeilederBarnestipendAppState } from '../Store';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { BarnestipendSatser } from '../Utilities/BarnestipendApi';
import { BoksC1 } from '../Models/Ids';

import ResultatComponent from './ResultatComponent';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import { ResultatSectionComponent } from './ResultatSectionComponent';

interface CaResultOwnProps {
    eventId: string | null;
}

type C1ResultatProps = MapStateToProps & MapDispatchToProps & CaResultOwnProps;

class C1ResultatComponent extends React.PureComponent<C1ResultatProps> {
    constructor(props: C1ResultatProps) {
        super(props);
    }

    render(): JSX.Element | null {
        const { epiContext, satser, locale, eventId } = this.props;

        if (satser === null) {
            return null;
        }

        const ar = satser.Ar.toString();

        const inntektEgen = tilPengerFormat(satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X, locale);

        const inntektEktefelle = tilPengerFormat(satser.SATS_ST04_INNTEKTSGRENSE_EKTEFELLE, locale);

        const formueFelles = tilPengerFormat(satser.SATS_ST04_FORMUEGRENSE_GIFT, locale);

        return (
            <ResultatComponent
                boksId={BoksC1}
                tittelInntekt="restulatToForeldreC1InntektsgrenserTittel"
                tittelFormueTrygd="restulatToForeldreC1GrenseFormueTittel"
                tittelKontroll="restulatToForeldreC1KontrollInntektTittel"
                innholdInntekt={
                    <div>
                        <ResultatSectionComponent
                            ar={ar}
                            epiContext={epiContext}
                            verdi={inntektEgen}
                            tekst="restulatToForeldreC1InntektsgrenserBrodtekstEgenInntekt"
                        />

                        <ResultatSectionComponent
                            ar={ar}
                            epiContext={epiContext}
                            verdi={inntektEktefelle}
                            tekst="restulatToForeldreC1InntektsgrenserBrodtekstEktefelleInntekt"
                        />
                    </div>
                }
                innholdFormueTrygd={
                    <ResultatSectionComponent
                        ar={ar}
                        epiContext={epiContext}
                        verdi={formueFelles}
                        tekst="restulatToForeldreC1GrenseFormueBrodtekst"
                    />
                }
                innholdKontroll={contentResolver(epiContext, 'restulatToForeldreC1KontrollInntektBrodtekst')}
                eventId={eventId}
            />
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederBarnestipendDto>;
    satser: BarnestipendSatser | null;
    locale: string;
}

interface MapDispatchToProps {}

export default connect(
    (state: VeilederBarnestipendAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            satser: state.satser,
            locale: state.epiContext.locale,
        };
    },
)(C1ResultatComponent);
